import { render, staticRenderFns } from "./GenerateNewCoupons.vue?vue&type=template&id=67819245&"
import script from "./GenerateNewCoupons.vue?vue&type=script&lang=js&"
export * from "./GenerateNewCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports